import { render, staticRenderFns } from "./Perron.vue?vue&type=template&id=2cb86492&scoped=true"
import script from "./Perron.vue?vue&type=script&lang=js"
export * from "./Perron.vue?vue&type=script&lang=js"
import style0 from "./Perron.vue?vue&type=style&index=0&id=2cb86492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb86492",
  null
  
)

export default component.exports